import { useEffect, useState, useMemo, createRef } from "react"
import { Slider, message } from "antd"
import { useSnapshot } from "valtio"
import { timerFormat, jumpRouter, getMusicUrl } from "@/common/common"
import playStore, { prevSong, nextSong } from "@/store/play"
import generalStore, {
  toggleVisualFlag,
  togglePlayFlag,
  changePlayFlagType
} from "@/store/general"
import Audio from "./audio"
import PlayBox from "./playBox"
import styles from "../css/footer.modules.less"

const Footer = () => {
  const { playObj } = useSnapshot(playStore)
  const { playFlag } = useSnapshot(generalStore)
  const [isInit, setInit] = useState(true)
  const [playStatus, setPlayStatus] = useState(false)
  const [picUrl, setPicUrl] = useState("")
  const [timer, setTimer] = useState()
  const [inputValue, setInputValue] = useState(50)
  const [palyType, setPlayType] = useState(1)
  const [volumeFlag, setVolumeFlag] = useState("open")
  const [messageApi, content] = message.useMessage()

  const audioRef = createRef()
  const playBoxRef = createRef()

  const timeCallback = useMemo(() => {
    return timerFormat(timer)
  }, [timer])

  // 此处执行这个方法是因为处于正在播放的歌曲的url地址网易云那边是个变化的数据，歌曲地址基本上隔天就会变化
  useEffect(() => {
    if (playObj.id) getMusicUrl(playObj.id, 1)
  }, [])
  useEffect(() => {
    // console.log("播放对象更改了")
    setPicUrl(playObj.picUrl)
  }, [playObj.id])
  useEffect(() => {
    setInit(false)
    // 如果是初始化不执行此逻辑
    if (isInit) return
    togglePlay(playFlag)
  }, [playFlag])
  // 暂停与播放
  const playChange = (val) => {
    if (!playObj.id) {
      messageApi.open({
        type: "warning",
        content: "请您先选择一首歌曲哦！"
      })
      return
    }
    // console.log(val)
    let flag = val // 这个val要么得console一下要么得重新赋值页面才会初始化可视化样式，很奇怪？？？
    togglePlay(val)
    changePlayFlagType("footer")
    togglePlayFlag(flag)
  }
  const togglePlay = (val) => {
    if (!playObj.url) return
    audioRef.current.cancelListener()
    if (val) audioRef.current.play()
    else audioRef.current.pause()
    setPlayStatus(val)
  }

  // 上一首与下一首
  const preAndNext = (val) => {
    if (!playStore.pbList.length) {
      messageApi.open({
        type: "warning",
        content: "播放列表为空"
      })
      return
    }
    if (val == "pre") prevSong()
    else if (val == "next") nextSong()
  }
  // 设置当前播放时间
  const curTime = (val) => {
    // console.log(val)
    setTimer(val * 1000)
  }
  // 设置歌曲的播放状态
  const setAudioStatus = (val) => {
    if (val == "play") setPlayStatus(true)
    else if (val == "pause") setPlayStatus(false)
  }
  // 音量变化回调
  const voiceChange = (val) => {
    // console.log(val)
    if (isNaN(val)) return
    setInputValue(val)
    audioRef.current.volumeChange(val / 100)
  }
  // 开启关闭声音
  const volumeToggle = (val) => {
    if (val == "close") audioRef.current.volumeChange(0)
    else if (val == "open") audioRef.current.volumeChange(inputValue / 100)
    setVolumeFlag(val)
  }
  // 播放类型更改
  const changePlayType = (val) => {
    setPlayType(val)
  }
  // 查看播放列表
  const lookPlayBox = (e) => {
    // console.log(e)
    // console.log(audioRef.current)
    playStore.pbFlag = true
  }

  return (
    <div className={styles.footerBox}>
      {content}
      <div className="left">
        <i
          title="上一首"
          className="iconfont footer-icon"
          onClick={() => preAndNext("pre")}
        >
          &#xe67e;
        </i>
        {playStatus ? (
          <i
            title="暂停"
            className="iconfont footer-icon play-icon"
            onClick={() => playChange(false)}
          >
            &#xe662;
          </i>
        ) : (
          <i
            title="播放"
            className="iconfont footer-icon play-icon"
            onClick={() => playChange(true)}
          >
            &#xe667;
          </i>
        )}
        <i
          title="下一首"
          className="iconfont footer-icon"
          onClick={() => preAndNext("next")}
        >
          &#xe67c;
        </i>
      </div>
      <div className="middle">
        <img
          src={picUrl ? picUrl : "http://pic.mrzhj.cn/caigou/caigou26.png"}
          alt=""
          className="avatar"
          onClick={toggleVisualFlag}
        />
        <div className="music-wrap">
          <div className="title">
            <p className="txt ov1">
              {playObj.fee == 1 && (
                <i className="iconfont vip-icon">&#xe70a;</i>
              )}
              <span
                className="txt1 hover"
                onClick={() => jumpRouter("song", playObj.id)}
              >
                {playObj.name}
              </span>
              <span>&emsp;</span>
              {playObj.singer.map((item, index) => (
                // 此处用那么name做key是因为有的歌手没牌面没有ID，加index是因为存在名字一样的情况
                <span key={item.name + index}>
                  {item.id ? (
                    <span
                      className="txt2 hover"
                      onClick={() => jumpRouter("singer", item.id)}
                    >
                      {item.name}
                    </span>
                  ) : (
                    <span>{item.name}</span>
                  )}

                  {index < playObj.singer.length - 1 && <span>/</span>}
                </span>
              ))}
              &nbsp;--&nbsp;
              <span
                className="txt3 hover"
                onClick={() => jumpRouter("siname", playObj.sinameId)}
              >
                {playObj.siname}
              </span>
            </p>
            <p className="time">
              <span>{timer ? timeCallback : "00:00"}</span>
              &nbsp;/&nbsp;
              <span>{playObj.dt ? timerFormat(playObj.dt) : "00:00"}</span>
            </p>
          </div>
          <Audio
            ref={audioRef}
            setCurTimer={(val) => curTime(val)}
            audioStatus={(val) => setAudioStatus(val)}
            nextMusic={() => nextSong()}
          ></Audio>
        </div>
        <PlayBox ref={playBoxRef}></PlayBox>
      </div>
      <div className="right">
        {palyType === 1 && (
          <i
            className="iconfont right-icon"
            title="列表循环"
            onClick={() => changePlayType(2)}
          >
            &#xe605;
          </i>
        )}
        {palyType === 2 && (
          <i
            className="iconfont right-icon"
            title="单曲循环"
            onClick={() => changePlayType(3)}
          >
            &#xe604;
          </i>
        )}
        {palyType === 3 && (
          <i
            className="iconfont right-icon"
            title="随机播放"
            onClick={() => changePlayType(1)}
          >
            &#xe606;
          </i>
        )}
        <i
          id="playListIcon"
          className="iconfont right-icon"
          title="播放列表"
          onClick={(e) => lookPlayBox(e)}
        >
          &#xe86a;
        </i>
        {volumeFlag == "open" ? (
          <i
            title="音量"
            className="iconfont right-icon"
            onClick={() => volumeToggle("close")}
          >
            &#xe63d;
          </i>
        ) : (
          <i
            title="静音"
            className="iconfont right-icon"
            onClick={() => volumeToggle("open")}
          >
            &#xe63e;
          </i>
        )}
        <Slider
          className="voice"
          min={0}
          max={100}
          onChange={voiceChange}
          value={typeof inputValue === "number" ? inputValue : 0}
          tooltip={{
            color: "#0f9d94"
          }}
        />
      </div>
    </div>
  )
}
export default Footer
